import { render, staticRenderFns } from "./ApproveDocumentConfirmModal.vue?vue&type=template&id=1cd062dc&"
import script from "./ApproveDocumentConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./ApproveDocumentConfirmModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports